module.exports = __webpack_public_path__ + "static/img/20.cd85402.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/KidsWishes/Items3/20.png
// module id = 181
// module chunks = 0